module.exports = "/_next/static/images/first-home_lower-deposit-desktop-6934ddea9ed7e636d03971fbaf06d2f2.svg";